import {
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
} from "@mui/material";
import Typography from "common/components/Typography";
import React, { useContext, useState } from "react";
import GenshinDialog from "common/components/GenshinDialog";
import { useTranslation } from "react-i18next";
import { ContentCopy, Visibility, VisibilityOff } from "@mui/icons-material";
import { RoomContext } from "App/context";
import { GameModeDictionary, PlayersNumberDictionary } from "types/Room/type";
import { formatTimer } from "common/utils";

type ParamsDialogProps = {
  open: boolean;
  onClose: () => void;
};

const ParamsDialog = (props: ParamsDialogProps) => {
  const { open, onClose } = props;
  const { params, draftModel } = useContext(RoomContext);
  const { t } = useTranslation();

  return (
    <GenshinDialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
      <DialogTitle>
        <Typography>{t("Informations du salon")}</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack gap={2} paddingY={1}>
          <Typography size="sm">
            {t("Nom du salon")} : {params.name}
          </Typography>
          <Typography size="sm">
            {t("Privé")} : {params.privateRoom ? t("Oui") : t("Non")}
          </Typography>
          <Typography size="sm">
            {t("Mode de jeu")} : {t(GameModeDictionary[params.gameMode])}
          </Typography>
          <Typography size="sm">
            {t("Feuille d'équilibrage")} : {params.sheet.name}
          </Typography>
          <Typography size="sm">
            {t("Nombre de joueurs")} :{" "}
            {PlayersNumberDictionary[params.playersNumber]}
          </Typography>
          <Typography size="sm">
            {t("Temps par joueur")} :{" "}
            {draftModel.timer > 0
              ? formatTimer(draftModel.timer)
              : t("Illimité")}
          </Typography>
          {params.solo && <Typography size="sm">{t("Solo")}</Typography>}
        </Stack>
      </DialogContent>
    </GenshinDialog>
  );
};

export default ParamsDialog;
